const dev = {
    cognito: {
        REGION: "us-east-2",
        USER_POOL_ID: "us-east-2_ZDIWZvyYR",
        APP_CLIENT_ID: "ug3gfq7g8tsoarnhjdhq1llhm",
        IDENTITY_POOL_ID: "us-east-2:ae2c87fc-beba-4844-8b09-0c9ab8e6684d"
    }
};

const prod = {
    cognito: {
        REGION: "us-east-2",
        USER_POOL_ID: "us-east-2_ZDIWZvyYR",
        APP_CLIENT_ID: "ug3gfq7g8tsoarnhjdhq1llhm",
        IDENTITY_POOL_ID: "us-east-2:ae2c87fc-beba-4844-8b09-0c9ab8e6684d"
    }
};

// Default to dev if not set
const config = process.env.REACT_APP_STAGE === 'prod'
    ? prod
    : dev;

export default {
    // Add common config values here
    MAX_ATTACHMENT_SIZE: 5000000,
    ...config
};

